import { getCurrentInstance } from 'vue';
import { useVuelidate } from '@vuelidate/core';

// Vue 3 migration bridge for Vuelidate.
//
// Vuelidate 0.x was a global plugin that injected `this.$v` derived from a
// component's `validations` Options-API field. @vuelidate/core 2 is
// composition-first and ships no such global. This mixin restores the old
// Options-API surface so the ~31 existing forms keep working unchanged.
//
// IMPORTANT: applied as a GLOBAL mixin, but `useVuelidate()` is only invoked
// for components that actually declare a `validations` option. Calling it on
// every component made @vuelidate/core eagerly evaluate unrelated component
// computeds during setup() (before data()/options applied), crashing
// components like ChatList. Gating on `validations` keeps the bridge inert
// everywhere else.
export const vuelidateBridge = {
  setup() {
    const instance = getCurrentInstance();
    // Vue SFCs compiled by vue-loader keep Options API fields on __vccOpts.
    // eslint-disable-next-line no-underscore-dangle
    const componentOptions = instance?.type?.__vccOpts || instance?.type;
    const hasValidations = Boolean(
      componentOptions && componentOptions.validations
    );
    if (!hasValidations) {
      return {};
    }
    const v$ = useVuelidate();
    return { v$ };
  },
  computed: {
    $v() {
      return this.v$;
    },
  },
};

export default vuelidateBridge;
